import { useBlockedModal } from 'containers/common/blockedModal/useBlockedModal'
import { usePrivacyPolicyModal } from 'containers/createAccount/components/privacyPolicyModal/usePrivacyPolicyModal'
import { useWelcomeModal } from 'containers/common/welcomeModal/useWelcomeModal'
import { useConfirmLogoutModal } from 'containers/common/confirmLogoutModal/useConfirmLogoutModal'
import { useVerifyEmailModal } from 'containers/createAccount/components/verifyEmailModal/useVerifyEmailModal'
import { useState } from 'react'
import { FormFieldsData } from 'types/form'

interface Props {
  isBlockedModalOpen: boolean
  setIsBlockedModalOpen: (isOpen: boolean) => void
  setIsWelcomeModalOpen: (isOpen: boolean) => void
  handleShowCreateAccountForm: () => void
  isWelcomeModalOpen: boolean
  formData: FormFieldsData
  isVerifyEmailModalOpen: boolean
  setIsVerifyEmailModalOpen: (isOpen: boolean) => void
  handleSendNewCode: () => Promise<void>
}

export const useCreateAccountModals = ({
  isBlockedModalOpen,
  setIsBlockedModalOpen,
  setIsWelcomeModalOpen,
  handleShowCreateAccountForm,
  isWelcomeModalOpen,
  formData,
  isVerifyEmailModalOpen,
  setIsVerifyEmailModalOpen,
  handleSendNewCode,
}: Props) => {
  const [isConfirmationLogoutModalOpen, setIsConfirmationLogoutModalOpen] = useState(false)
  const [isPrivacyPolicyModalOpen, setIsPrivacyPolicyModalOpen] = useState(false)
  const { BlockedModal } = useBlockedModal(isBlockedModalOpen, setIsBlockedModalOpen)
  const { PrivacyPolicyModal, handlePrivacyPolicyModalOpen } = usePrivacyPolicyModal(
    isPrivacyPolicyModalOpen,
    setIsPrivacyPolicyModalOpen,
  )
  const { WelcomeModal } = useWelcomeModal({
    setIsConfirmationLogoutModalOpen,
    setIsWelcomeModalOpen,
    handleShowCreateAccountForm,
    isWelcomeModalOpen,
  })

  const { ConfirmationLogoutModal } = useConfirmLogoutModal({
    isConfirmationLogoutModalOpen,
    setIsConfirmationLogoutModalOpen,
    setIsWelcomeModalOpen,
    handleShowCreateAccountForm,
  })

  const { VerifyEmailModal } = useVerifyEmailModal({
    formData,
    isOpen: isVerifyEmailModalOpen,
    setIsVerifyEmailModalOpen,
    handleSendNewCode,
  })

  const Modals = (
    <>
      {WelcomeModal}
      {PrivacyPolicyModal}
      {VerifyEmailModal}
      {BlockedModal}
      {ConfirmationLogoutModal}
    </>
  )

  return {
    Modals,
    handlePrivacyPolicyModalOpen,
  }
}
